'use client'

import Script from 'next/script'

export default function GoogleAnalytics({ gaId }: { gaId: string }) {
  return (
    <>
      <Script
        strategy="lazyOnload"
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
      />
      <Script
        id="google-analytics"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${gaId}', {
              page_path: window.location.pathname,
            });

            // Mesurer les demandes de contact sans collecter le contenu des échanges.
            document.addEventListener('click', function (event) {
              var target = event.target;
              if (!(target instanceof Element)) return;
              var link = target.closest('a');
              if (!link) return;
              var href = link.getAttribute('href') || '';

              if (href.indexOf('tel:+33619607081') === 0) {
                gtag('event', 'generate_lead', { method: 'phone' });
              } else if (href.indexOf('mailto:contact@lena-lahor-coaching.fr') === 0) {
                gtag('event', 'generate_lead', { method: 'email' });
              } else if (/wa\.me|api\.whatsapp\.com/i.test(href)) {
                gtag('event', 'generate_lead', { method: 'whatsapp' });
              } else if (/cal\.com|calendly\.com/i.test(href)) {
                // Un clic indique une intention de réserver, pas un rendez-vous confirmé.
                gtag('event', 'booking_link_click', {
                  booking_provider: /cal\.com/i.test(href) ? 'cal.com' : 'calendly',
                });
              }
            });
          `,
        }}
      />
    </>
  )
}
